import { PadPosition } from "../presentationType";
import { BinaryPresentation } from "./binaryPresentation";

export class BinaryLittleEndianBitLittleEndianPresentation extends BinaryPresentation {
    public constructor() {
        super("binary-ByteLittleEndian-BitLittleEndian");
    }

    public toInternalRepresentation(input: string): string {
        return this.splitIntoPiecesOfSize(this.padToFullByte(input, PadPosition.END), 8)
            .reverse()
            .map(this.reverseString)
            .join("");
    }

    public fromInternalRepresentation(numberPresentation: string): string {
        return this.splitIntoPiecesOfSize(this.padToFullByte(numberPresentation, PadPosition.START), 8)
            .reverse()
            .map(this.reverseString)
            .join("");
    }
}